import React, { useEffect } from "react";
import "./modal.scss";
import Button from "components/Button/index";
import GetActionIcon from "constants/Homepage/ysafe/iconFunctions/getActionIcon";
import useTheme from "hooks/observer";

const Modal = ({
  isDisabled = false,
  children,
  heading = "",
  submitBtnText = "Upload",
  submitBtnColor = "violet",
  closeBtnColor = "white",
  closeBtnTxt = "Cancel",
  showFooter = true,
  showHeader = true,
  showCross = true,
  closable = true,
  handleSave = () => { },
  handleCancel = () => { },
  customClass,
  width = "20%",
  closeIcon,
  customHeader,
  description = "",
  containerClass = ""
}) => {
  useEffect(() => {
    document.body.style.overflow = "hidden";

    const handleOutsideClick = (e) => {
      const modalElement = document.querySelector(".modalContainer");
      if (modalElement && !modalElement.contains(e.target)) {
        handleCancel();
      }
    };

    if (closable) {
      document.addEventListener("mousedown", handleOutsideClick);
    }

    return () => {
      document.body.style.overflow = "auto";
      if (closable) {
        document.removeEventListener("mousedown", handleOutsideClick);
      }
    };
  }, [closable, handleCancel]);
  useEffect(() => {
    const handleKeyDown = (e) => {
      // Ignore Enter if user is typing in input or textarea
      const tag = e.target.tagName.toLowerCase();
      if (tag === "input" || tag === "textarea") return;

      if (e.key === "Enter" && !isDisabled) {
        e.preventDefault();
        handleSave();
      }
    };

    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [handleSave, isDisabled]);





  const theme = useTheme();

  return (
    <div
      className="modal"
      onClick={(event) => {
        event.stopPropagation(); // Prevents event bubbling
      }}
    >
      <div
        className={`modalContainer ${containerClass}`}
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        {customHeader && (
          <div className="customModalHeader">
            <div className="headerBox">
              <p className="headerTitle">{heading}</p>
              <p className="headerDescription">{description}</p>
              {showCross && (
                <div className="cross" onClick={handleCancel}>
                  <GetActionIcon
                    type="cross"
                    color={theme === "light" ? "#7D708A" : "#BDB8C2"}
                  />
                </div>
              )}
            </div>
          </div>
        )}
        {showHeader && (
          <div className="modalHeader">
            <p>{heading}</p>
            {showCross && (
              <div className="cross" onClick={handleCancel}>
                <GetActionIcon
                  type="cross"
                  color={theme === "light" ? "#7D708A" : "#BDB8C2"}
                />
              </div>
            )}
          </div>
        )}
        {children}
        {showFooter && (
          <div className={customClass ?? "modalFooterContainer"}>
            <Button
              type={closeBtnColor}
              width={width}
              title={closeBtnTxt}
              onClick={handleCancel}
            />
            <Button
              disabled={isDisabled}
              type={submitBtnColor}
              width={width}
              title={submitBtnText}
              onClick={handleSave}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default Modal;
